import { render, staticRenderFns } from "./BaseModalWithLogo.vue?vue&type=template&id=d97a78c2&scoped=true"
import script from "./BaseModalWithLogo.vue?vue&type=script&lang=js"
export * from "./BaseModalWithLogo.vue?vue&type=script&lang=js"
import style0 from "./BaseModalWithLogo.vue?vue&type=style&index=0&id=d97a78c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97a78c2",
  null
  
)

export default component.exports